import React from "react";
import { Grid } from "semantic-ui-react";
import { Form, Format } from "@redriver/cinnamon";
import { UserTypeCheck } from "features/../../../shared/components/auth";
import { UserType } from "features/../../../shared/constants/enums";
import {FormattedNumericInput} from "../../../components/forms";

const DealerChargeColumn = ({
  title,
  column,
  readOnly,
  includeIpSyndicateCharge,
}) => (
  <Grid.Column width={2}>
    <Grid.Row>
      <p>{title}</p>
    </Grid.Row>
    <Grid.Row>
      <FormattedNumericInput
        field="disclosedPercentage"
        subLabel="%"
        subLabelPosition="right"
        decimalPlaces={3}
        readOnly={readOnly}
        onFocus={e => e.target.select()}
        renderReadOnly={props => (
          <Format.Number
            format="percentage"
            value={column.disclosedPercentage}
            decimalPlaces={{ min: 0, max: 3 }}
          />
        )}
      />
    </Grid.Row>
    <Grid.Row>
      <FormattedNumericInput
        field="undisclosedPercentage"
        subLabel="%"
        subLabelPosition="right"
        decimalPlaces={3}
        readOnly={readOnly}
        onFocus={e => e.target.select()}
        renderReadOnly={props => (
          <Format.Number
            format="percentage"
            value={column.undisclosedPercentage}
            decimalPlaces={{ min: 0, max: 3 }}
          />
        )}
      />
    </Grid.Row>
    <Grid.Row>
      <Format.Number
        format="percentage"
        field="total"
        value={getTotal(column.disclosedPercentage, column.undisclosedPercentage)}
        decimalPlaces={{ min: 0, max: 3 }}
      />
    </Grid.Row>

    <UserTypeCheck restrictTo={UserType.HQ}>
      <Grid.Row className="ip-syndicate">
        <FormattedNumericInput
          field="ipSyndicate"
          subLabel="%"
          subLabelPosition="right"
          decimalPlaces={3}
          readOnly={readOnly}
          onFocus={e => e.target.select()}
          renderReadOnly={props => (
            <Format.Number
              format="percentage"
              value={column.ipSyndicate}
              decimalPlaces={{ min: 0, max: 3 }}
            />
          )}
        />
      </Grid.Row>{" "}
      <Grid.Row className="ips-v-minimum">
        <FormattedNumericInput
          field="ipSyndicateVMinimum"
          subLabel="%"
          subLabelPosition="right"
          decimalPlaces={3}
          readOnly={readOnly}
          onFocus={e => e.target.select()}
          renderReadOnly={props => (
            <Format.Number
              format="percentage"
              value={column.ipSyndicateVMinimum}
              decimalPlaces={{ min: 0, max: 3 }}
            />
          )}
        />
      </Grid.Row>
    </UserTypeCheck>
  </Grid.Column>
);

const getTotal = (w, x) =>
  parseFloat(w) + parseFloat(x);

export default DealerChargeColumn;
